import { get } from "lodash";
import { createSelector } from "reselect";
import { TESTING_ENVIRONMENTS } from "./configConstants.js";

// -- QUERIES -- //

const environmentQuery = state =>
  get(state, "config.data.APP_ENVIRONMENT", null);

// -- SELECTORS -- //

export const selectTestingEnvironment = createSelector(
  [environmentQuery],
  environment => {
    const testing_environment = TESTING_ENVIRONMENTS.find(
      item => item === environment
    );
    return testing_environment ? environment : null;
  }
);

// using the following export pattern so we can mock more easily using jest

const configSelectors = {
  selectTestingEnvironment
};

export default configSelectors;
